import React, { FC } from 'react';
import { formatPersonalCode } from 'common/utils';
import ProfileLink from './ProfileLink';

interface IMemberLink {
  id: string | number;
  firstName: string;
  lastName: string;
  path?: string;
}

const MemberLink: FC<IMemberLink> = ({ id, firstName, lastName, path = '/members' }) => {
  const label = `${formatPersonalCode(Number(id))} - ${firstName} ${lastName}`;
  return <ProfileLink label={label} path={`${path}/${id}`} />;
};

export default MemberLink;
